import { render, staticRenderFns } from "./synchronize-time.vue?vue&type=template&id=4b92ee98&scoped=true&"
import script from "./synchronize-time.vue?vue&type=script&lang=js&"
export * from "./synchronize-time.vue?vue&type=script&lang=js&"
import style0 from "./synchronize-time.vue?vue&type=style&index=0&id=4b92ee98&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b92ee98",
  null
  
)

export default component.exports